import { FeatureFlag } from '@/constants/featureFlags'
import { useAuth } from '@/contexts/AuthContext'

export function useFeatureFlag(flag: FeatureFlag): boolean {
  const { userProfile } = useAuth()
  return userProfile?.featureFlags?.[flag] ?? false
}
